import { type ConfigSection, type GameProfile, type Menu, MenuItem, type ProfileCtx } from "./types";
import defaultProfile, { asyncRoute } from "@/game_profiles/default";
import { commonMenuItems } from "@/game_profiles/common";
import { usePermissions } from "@/util/permissions";
import { faPuzzlePiece } from "@fortawesome/pro-solid-svg-icons";
import { useServiceStore } from "@/store/service";
import { usePropertyBuilder } from "@/components/views/config/helpers";
import { computed } from "vue";
import type { DeadsideConsoleProfileNamespace, ModioMod } from "@/graphql";
import { useModioMods } from "@/components/views/mods/modio";
import type { IUseMods } from "@/components/views/mods";

const configSections: ConfigSection[] = [{ component: "ConfSection", props: { name: "basic" } }];

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  const { isAdmin } = usePermissions();
  if (isAdmin.value) {
    menu[0].items.push(commonMenuItems.logs);
    menu[0].items.push(commonMenuItems.console);
  }
  menu[0].items.push(
    new MenuItem(
      "mods",
      faPuzzlePiece,
      asyncRoute(() => import("../components/views/config/deadside/ConsoleMods.vue")),
      [
        {
          route: "manage",
          component: asyncRoute(() => import("../components/views/mods/manage/ModsManage.vue")),
        },
      ],
    ),
  );
  return menu;
};

export function useMods() {
  const service = useServiceStore();
  const { buildProperty } = usePropertyBuilder();

  const profile = computed(() => service.ctx.profile as DeadsideConsoleProfileNamespace | undefined);
  const selectedModioMods = computed(() => profile.value?.selectedModioMods ?? []);
  const modIds = buildProperty<Array<string>>("virtual", "mods", []);
  return useModioMods(selectedModioMods, modIds);
}

export default (_ctx: ProfileCtx): Partial<GameProfile<ModioMod, IUseMods<ModioMod>>> => ({
  configSections,
  useMods,
  menu: createMenu(),
});
